var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext } from "react";
import { Divider, Flex, Select, Stack } from "@reverb-ui/react";
import { ClientEmployeeContext } from "@/shared/presentation/context-api/providers/client-employee";
import { CompanyOwnerContact } from "../company-owner-contact";
import { CompanyOwnerAddress } from "../company-owner-address";
import { CompanyOwnerInformation } from "../company-owner-information";
import { ModalCompanyOwnerAddress } from "../modal-company-owner-address";
import { ModalCompanyOwnerContact } from "../modal-company-owner-contact";
import { ModalCompanyOwnerInformation } from "../modal-company-owner-information";
import { useTranslation } from "react-i18next";
import { CompanyCard } from "../company-card";
export var CompanyOwner = function () {
    var _a, _b;
    var t = useTranslation("my-account").t;
    var _c = useContext(ClientEmployeeContext), employee = _c.employee, client = _c.client, clientAddresses = _c.clientAddresses, clientContacts = _c.clientContacts, handleClientChange = _c.handleClientChange, isOwnerOrAdminOfSelectedClient = _c.isOwnerOrAdminOfSelectedClient, submitAddresses = _c.submitAddresses, submitContacts = _c.submitContacts, submitInformation = _c.submitInformation;
    var _d = React.useState(false), isAddressModalOpen = _d[0], setIsAddressModalOpen = _d[1];
    var _e = React.useState(false), isContactModalOpen = _e[0], setIsContactModalOpen = _e[1];
    var _f = React.useState(false), isInformationModalOpen = _f[0], setIsInformationModalOpen = _f[1];
    var toggleModalAddressVisibility = function () {
        setIsAddressModalOpen(function (oldValue) { return !oldValue; });
    };
    var toggleModalContactVisibility = function () {
        setIsContactModalOpen(function (oldValue) { return !oldValue; });
    };
    var toggleModalInformationVisibility = function () {
        setIsInformationModalOpen(function (oldValue) { return !oldValue; });
    };
    var listClientSelect = employee.clients.map(function (client) {
        return {
            label: client.name,
            value: client.rockId,
        };
    });
    var selectedClient = client
        ? listClientSelect.find(function (c) { return c.value === client.rockId; })
        : null;
    var onClientChange = function (selected) {
        handleClientChange(selected.value);
    };
    var onSubmitAddressForm = function (addressesToDelete, addressesToUpdate, addressesToCreate) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, submitAddresses(addressesToDelete, addressesToUpdate, addressesToCreate)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmitContactForm = function (contactsToDelete, contactsToUpdate, contactsToCreate) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, submitContacts(contactsToDelete, contactsToUpdate, contactsToCreate)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmitInformationForm = function (clientInformationToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, submitInformation(clientInformationToUpdate)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { direction: "column", alignItems: "flex-end", justifyContent: "center", m: "16px 32px" },
            React.createElement(Flex, { direction: "column", alignItems: "flex-start", justifyContent: "center", p: "0", w: "full" },
                React.createElement(Flex, { direction: "column", alignItems: "flex-start", p: "0", w: "full" },
                    ((_a = employee === null || employee === void 0 ? void 0 : employee.clients) === null || _a === void 0 ? void 0 : _a.length) > 1 && (React.createElement(Flex, { direction: "row", alignItems: "flex-start", p: "0", w: "full", h: "51", mb: "24px" },
                        React.createElement(Stack, { flex: "1" },
                            React.createElement(Select, { label: t("company"), onChange: onClientChange, value: selectedClient, options: listClientSelect })))),
                    client && !isOwnerOrAdminOfSelectedClient() && (React.createElement(CompanyCard, { name: client.tradeName || client.name, industry: ((_b = client === null || client === void 0 ? void 0 : client.industry) === null || _b === void 0 ? void 0 : _b.description) || "-" })),
                    client && isOwnerOrAdminOfSelectedClient() && (React.createElement(CompanyOwnerInformation, { client: client, toggleModalInformationVisibility: toggleModalInformationVisibility })))),
            client && isOwnerOrAdminOfSelectedClient() && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { mt: "8px", mb: "24px" }),
                React.createElement(CompanyOwnerContact, { clientContacts: clientContacts, toggleModalContactVisibility: toggleModalContactVisibility }),
                React.createElement(Divider, { mt: "8px", mb: "24px" }),
                React.createElement(CompanyOwnerAddress, { clientAddresses: clientAddresses, tottleModalAddressVisibility: toggleModalAddressVisibility })))),
        client && (React.createElement(React.Fragment, null,
            React.createElement(ModalCompanyOwnerAddress, { isOpen: isAddressModalOpen, addresses: clientAddresses, onClose: function () { return toggleModalAddressVisibility(); }, onSubmit: onSubmitAddressForm }),
            React.createElement(ModalCompanyOwnerContact, { isOpen: isContactModalOpen, contacts: clientContacts, onClose: function () { return toggleModalContactVisibility(); }, onSubmit: onSubmitContactForm }),
            React.createElement(ModalCompanyOwnerInformation, { isOpen: isInformationModalOpen, clientInformation: client, onClose: function () { return toggleModalInformationVisibility(); }, onSubmit: onSubmitInformationForm })))));
};
